// Profile.js
import { useUser } from '../../context/UserContext';

const Profile = () => {
  const { user, loading } = useUser();
  // You can use user and loading here if you want to display profile info
  return null;
};

export default Profile;
